// You can find the id here
// https://portal.sourcepoint.com/consent_v2/vendor_lists/edit?id=6233296a293cdf6b366969ee&non_iab=false
// Vendor: Facebook
const FACEBOOK_ID: string = '5e7e1298b8e05c54a85c52d2';
export default (grants: TSourcePointGrants): boolean => {
  return grants[FACEBOOK_ID]?.vendorGrant;
};
